/* eslint-disable max-lines */
import { EyeIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useSearch } from "../../hooks/useSearch";
import { IAffiliateFinancialSummary } from "../../interfaces/endpoints/IAffiliates";
import { getAffiliateFinancialSummaries } from "../../services/Affiliates.service";
import IconBtn from "../ui/IconBtn";
import Table, { Row } from "../ui/table";
import Pagination from "../ui/table/Pagination";
import { AffiliateStatusBadge } from "./AffiliateStatusBadge";
import AffiliateFinancialDetailsModal from "./AffiliateFinancialDetailsModal";

const columns = [
  "Partneri",
  "Email",
  "Kodi Promo",
  "Statusi",
  "Numri i shitjeve (Bus / eSIM)",
  "Fitimet totale",
  "Fitimet ne pritje",
  "Paguar totale",
  "Pagesa ne pritje",
  "Bilanci i disponueshem",
  "Veprimet"
];

const formatEuro = (value: number) =>
  `€${(value || 0).toFixed(2)}`;

const FinancialSummaryList = () => {
  const { response, loading, handlePageChange, page } = useSearch(
    getAffiliateFinancialSummaries,
    {
      withQuerySearch: true,
      withFilter: true,
      filterSelector: "status"
    }
  );

  const [selectedAffiliateId, setSelectedAffiliateId] = useState<number | null>(
    null
  );

  return (
    <div className="flex flex-col" style={{ height: "calc(100vh - 11rem)" }}>
      <Table
        titles={columns}
        loading={loading}
        className="overflow-x-auto"
        style="hover"
      >
        {(response?.data.result || []).map(
          (row: IAffiliateFinancialSummary, i: number) => (
            <Row
              key={i}
              affiliateName={row.affiliateName}
              email={row.email}
              promoCode={row.promoCode || "-"}
              status={<AffiliateStatusBadge status={row.status} />}
              salesCount={`${row.totalSalesCount} (${row.busSalesCount} / ${row.esimSalesCount})`}
              totalEarnings={formatEuro(row.totalEarnings)}
              pendingEarnings={formatEuro(row.pendingEarnings)}
              totalPaidOut={formatEuro(row.totalPaidOut)}
              pendingPayoutAmount={
                row.pendingPayoutAmount > 0
                  ? formatEuro(row.pendingPayoutAmount)
                  : "-"
              }
              availableBalance={
                <strong className={row.availableBalance > 0 ? "text-green-600" : ""}>
                  {formatEuro(row.availableBalance)}
                </strong>
              }
              actions={
                <IconBtn
                  className="w-6 h-6"
                  onClick={() => setSelectedAffiliateId(row.affiliateId)}
                >
                  <EyeIcon className="w-4 h-4" />
                </IconBtn>
              }
            />
          )
        )}
      </Table>
      <Pagination
        onPageChange={handlePageChange}
        totalCount={response?.data.totalCount || 0}
        length={response?.data?.result?.length}
        page={page}
        pageSize={10}
      />
      <AffiliateFinancialDetailsModal
        affiliateId={selectedAffiliateId}
        onClose={() => setSelectedAffiliateId(null)}
      />
    </div>
  );
};

export default FinancialSummaryList;
